import { NestedDeal } from "@revelate/types";

type PipelineRiskEmail = NonNullable<NestedDeal["emails"]>[number];

export type PipelineRiskEmailProjectionRow = Pick<
  PipelineRiskEmail,
  | "analysed_at"
  | "created_at"
  | "deal_id"
  | "id"
  | "provider"
  | "provider_data"
  | "provider_id"
  | "semantic_analysis"
  | "timestamp"
> & {
  sender_email?: string | null;
};

export function attachPipelineRiskEmailProjection(
  deals: NestedDeal[],
  emailRows: PipelineRiskEmailProjectionRow[],
) {
  const emailsByDeal = new Map<number, PipelineRiskEmailProjectionRow[]>();
  for (const email of emailRows) {
    const dealEmails = emailsByDeal.get(email.deal_id) ?? [];
    dealEmails.push(email);
    emailsByDeal.set(email.deal_id, dealEmails);
  }

  return deals.map(deal => ({
    ...deal,
    emails: (emailsByDeal.get(deal.id) ?? []).map(email => ({
      analysed_at: email.analysed_at,
      created_at: email.created_at,
      data: {
        from: {
          email: email.sender_email ?? null,
        },
      },
      deal_id: email.deal_id,
      id: email.id,
      provider: email.provider,
      provider_data: email.provider_data,
      provider_id: email.provider_id,
      semantic_analysis: email.semantic_analysis,
      timestamp: email.timestamp,
    })),
  }));
}
